export enum AnswerType {
  OneLine = "One Line",
  MultiLine = "Multi Line",
  Checkboxes = "Check Boxes",
  RadioButtons = "Radio Buttons",
}
